import script from "./WorkOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkOrder.vue?vue&type=script&setup=true&lang=js"

import "./WorkOrder.vue?vue&type=style&index=0&id=fe9e4ce4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe9e4ce4"]])

export default __exports__